import { logger } from "utils";
import { setIdp } from "./idpMapper";
import { setPoc } from "./pocMapper";

export const setDistrictData = (el = {}) => {
  const pocs = el.pocs?.map(setPoc) || [];
  const admin = pocs.filter((e) => e.type === "districtAdmin");
  try {
    return {
      createdAt: el.CreatedAt || el.created_at || null,
      updatedAt: el.UpdatedAt || el.updated_at || null,
      deletedAt: el.DeletedAt || el.deleted_at || null,
      id: el.ID || el.id || null,
      name: el.name || null,
      address: el.address || null,
      city: el.city || null,
      campus_count: el.campus_count || 0,
      building_count: el.building_count || 0,
      num_staff: el.num_staff || 0,
      num_students: el.num_students || 0,
      state: el.state || null,
      zip_code: el.zip_code || null,
      email: el.admin_email || (admin.length ? admin[0].email : null),
      logo_url: el.logo_url || null,
      lockdown_alert_method: el.lockdown_alert_method || "PUSH",
      invite_code: el.invite_code || null,
      account_owner_id: el.account_owner_id || null,
      created_by_id: el.created_by_id || null,
      idp_detail: setIdp(el.idp_detail),
      pocs,
      is_admin_invite_skipped: el.is_admin_invite_skipped || false,
      is_auth_provider_skipped: el.is_auth_provider_skipped || false,
    };
  } catch (error) {
    logger.error("Error in setDistrictData:", error, el);
    throw error;
  }
};
